import { render, staticRenderFns } from "./paginationButtons.vue?vue&type=template&id=d9def48e&scoped=true&"
import script from "./paginationButtons.vue?vue&type=script&lang=js&"
export * from "./paginationButtons.vue?vue&type=script&lang=js&"
import style0 from "./paginationButtons.vue?vue&type=style&index=0&id=d9def48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9def48e",
  null
  
)

export default component.exports